module.exports = __webpack_public_path__ + "static/media/photo212.9df2d701.jpg";